import { FC } from 'react';

import { useLocale } from 'hooks';

import { IconLanguageMark } from '../icons/IconLanguageWorld';
import { IconLanguageCloseArrows } from '../icons/IconLanguageCloseArrows';
import css from './LocaleButton.module.css';

type Props = {
  onClick: () => void;
};

export const LocaleButton: FC<Props> = ({ onClick }) => {
  const { locale } = useLocale();
  return (
    <button type="button" onClick={onClick} className={css.container}>
      <IconLanguageMark />
      {locale?.title}
      <IconLanguageCloseArrows />
    </button>
  );
};
